import { render, staticRenderFns } from "./registers.vue?vue&type=template&id=7853265c&scoped=true&"
import script from "./registers.vue?vue&type=script&lang=ts&"
export * from "./registers.vue?vue&type=script&lang=ts&"
import style0 from "./registers.vue?vue&type=style&index=0&id=7853265c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7853265c",
  null
  
)

export default component.exports